module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--risk risk pab2"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "risk__wrapper"
  }, [_c('h1', {
    staticClass: "h1",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Help is available")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Call "), _c('a', {
    staticClass: "tdn",
    attrs: {
      "href": ("tel:" + _vm.number)
    }
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v(" if you’d like to speak with someone.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Violence and thoughts of self-harm are serious matters that can be common during difficult moments. Our " + _vm._s(_vm.org.program_name) + " care team has certified counselors, available 24/7, that are ready to listen and direct you to the right help.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("If you are in crisis, call 911 now.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("If you are having an emergency right now, please call 911.")]), _vm._v(" "), _c('module-button', {
    attrs: {
      "button": "secondary",
      "link": "help-myself",
      "label": "Go back"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6012570c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/help/Risk.vue
// module id = 559
// module chunks = 0